import _ from 'lodash';
import { createSelector } from 'reselect';

import { safeJsonParse } from 'utils/json';
import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

const selectPosConfigurations = createSelector(
  getCompany,
  ({ posConfigurations }) => posConfigurations,
);

export const selectPosConfigurationsList = createSelector(
  selectPosConfigurations,
  ({ list }) => list,
);

export const selectPosConfigurationsTotalCount = createSelector(
  selectPosConfigurationsList,
  list => list.length,
);

export const selectFilteredPosConfigurations = createSelector(
  getDebouncedSearchValue,
  selectPosConfigurationsList,
  searchItems(config => [config.name, config.gtmId]),
);

export const selectDefaultPosConfiguration = createSelector(
  selectPosConfigurationsList,
  list => list.find(config => config.isDefault) ?? list[0] ?? null,
);

// the API returns `settings` as a JSON string; `colors` only exists inside it
export const selectDefaultPosConfigurationLogo = createSelector(
  selectDefaultPosConfiguration,
  config => _.get(safeJsonParse(config?.settings), 'colors.formControls.formsLogoUrl') ?? null,
);
